// 社区快搜
export default [
  {
    path: "peopleSearch",
    name: "peopleSearch",
    component: () =>
      import("@/views/communityFastSearch/peopleSearch.vue"),
    meta: {
      title: "人员搜索"
    }
  },
  {
    path: "homeSearch",
    name: "homeSearch",
    component: () =>
      import("@/views/communityFastSearch/homeSearch.vue"),
    meta: {
      title: "房屋搜索"
    }
  },
  {
    path: "recordIn",
    name: "recordIn",
    component: () =>
      import("@/views/communityFastSearch/recordIn.vue"),
    meta: {
      title: "进出记录"
    }
  },
  {
    path: "vehicleSearch",
    name: "vehicleSearch",
    component: () =>
      import("@/views/communityFastSearch/vehicleSearch.vue"),
    meta: {
      title: "车辆搜索"
    }
  }
];
